import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';

import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { MessageService, ToastMessageOptions } from 'primeng/api';
import { ToastToPrimengMessageConverter } from '../../converters/toast-to-primeng-message.converter';
import { ToastService } from '../../services/toast.service';
import { Toast } from '../../models/toast';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-toast',
  imports: [MessageModule, ToastModule],
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  providers: [MessageService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastComponent implements OnInit {
  private readonly toast = inject(ToastService);
  private readonly message = inject(MessageService);
  private readonly converter = inject(ToastToPrimengMessageConverter);

  private readonly destroyRef = inject(DestroyRef);

  public ngOnInit(): void {
    this.listenToShow();
  }

  private listenToShow(): void {
    this.toast.show$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((toast) => {
        this.showToastOnUI(this.convertToastToMessage(toast));
      });
  }

  private convertToastToMessage(toast: Toast): ToastMessageOptions {
    return this.converter.convert(toast);
  }

  private showToastOnUI(message: ToastMessageOptions): void {
    this.message.add(message);
  }
}
